import { render, staticRenderFns } from "./StatisticCard.vue?vue&type=template&id=5e285b14&scoped=true&"
import script from "./StatisticCard.vue?vue&type=script&lang=js&"
export * from "./StatisticCard.vue?vue&type=script&lang=js&"
import style0 from "./StatisticCard.vue?vue&type=style&index=0&id=5e285b14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e285b14",
  null
  
)

export default component.exports